import React, {useEffect, useContext, useState} from "react";
import styles from "./variantsFilterPicker/VariantsFilterPicker.module.scss";
import VariantItem from "./variantsFilterPicker/VariantItem";
import Activities from "./variantsFilterPicker/Activities";
import appContext from "../../../../../context/appContext";
import {Scrollbars} from "react-custom-scrollbars";
import http from "../../../../../services/api/utilities/http";

const VariantsFilterPicker = ({ title, handleSetVariantsFiltersList, removedItemId, selectedItems, themeColor }) => {

  const context = useContext(appContext);
  const [data, setData] = useState(null);
  const [variants, setVariants] = useState(null);
  const [activities, setActivities] = useState(null);
  const [selectedVariants, setSelectedVariants] = useState(selectedItems);

  const getData = () => {
    let uid = null;
    if (context.handleUid().uid) {
      uid = context.handleUid().uid;
    } else {
      uid = JSON.parse(localStorage.getItem("mapData")).uid;
    }

    http.get('process_mining/process_discovery/' + uid)
      .then(res => {
        setVariants(res.data.data.variants);
        setData(res.data.data);
      })
      .catch(err=>{
        console.log(err.response)
      })
  }

  useEffect(() => {
    if (JSON.stringify(selectedItems) !== JSON.stringify(selectedVariants)) {
      setSelectedVariants(selectedItems);
    }
  }, [selectedItems]);

  useEffect(() => {
    getData();
  }, []);

  const handleOnHover = (id) => {
    const nodes = data.nodes;
    const variantsList = variants.find(item => item.id === id).variant;
    const res = nodes.filter(item => variantsList.includes(item.id));
    setActivities(res);
  }

  const handleOnMouseLeave = () => {
    setActivities(null);
  }

  const handleRemoveFromList = (id) => {
    const selectedVariantsList = selectedVariants.filter(item => item !== id);
    setSelectedVariants(selectedVariantsList);
  }

  const handleSetSelectedVariants = (id) => {
    if (!selectedVariants.includes(id)) {
      setSelectedVariants([...selectedVariants, id]);
    } else {
      handleRemoveFromList(id)
    }
  }

  useEffect(() => {
    if (data && data.variants) {
      const passedData = data.variants.filter(item => selectedVariants.includes(item.id));
      handleSetVariantsFiltersList(passedData?.map(item => ({...item, is_active: 1})));
    }
  }, [selectedVariants]);

  useEffect(() => {
    handleRemoveFromList(removedItemId)
  }, [removedItemId])

  return (
    <div className={[styles.VariantsFilterPicker].join(' ')}>
      <div className={styles.contentsHeader}>
        { title }
      </div>
      <div className={['container-fluid', styles.fullHeight].join(' ')}>
        <div className={[styles.contentsBody, 'row'].join(' ')}>
          <div className={[styles.variantsSection].join(' ')}>
            <Scrollbars
              style={{paddingLeft: 4, paddingTop: 4}}
              renderView={({ style, ...props }) =>
                <div {...props} style={{ ...style, width: "100%", height: "100%", overflowX: 'hidden', paddingLeft: 24 }}/>}
              renderTrackVertical={({ style, ...props }) =>
                <div {...props} style={{ ...style, backgroundColor: '#C2C7ED', width: 1, borderRadius: 4, height: "100%" }}/>
              }
              renderThumbVertical={({ style, ...props }) =>
                <div {...props} style={{ ...style, backgroundColor: '#70789E', width: 4, borderRadius: 4, cursor: "pointer", left: -1}}/>
              }
            >
              {
                variants && variants.map(item => <VariantItem
                                                    key={item.id}
                                                    data={item}
                                                    handleOnHover={(id) => handleOnHover(id)}
                                                    handleOnMouseLeave={handleOnMouseLeave}
                                                    handleSetSelectedVariants={(id) => handleSetSelectedVariants(id)}
                                                    active={selectedVariants.includes(item.id)}
                                                    themeColor={themeColor}
                                                  />)
              }
            </Scrollbars>
          </div>
          <div className={[styles.activities, styles.fullHeight, 'd-md-none d-lg-flex align-content-start'].join(' ')}>
            {
              activities && activities.map(item => (
                <Activities title={item.name}/>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  )
};

export default VariantsFilterPicker;